import React from 'react';
import { BenefitDiscountCopy } from '@components/BenefitDiscountCopy/BenefitDiscountCopy';
import StepByStepList from '@components/StepByStepList/StepByStepList';
import BlockContent from '@components/block-content/BlockContent';
import { MetaData } from '@components/metaData/MetaData';
import CampaignBannerMapper from '../CampaignBannerMapper/CampaignBannerMapper';
import { BenefitTitle } from '../BenefitTitle/BenefitTitle';
import CtaButton from '../BenefitCallToActions/CtaButton';
import { LoaderContent } from '../../LoaderPage';
import { BenefitArticleLeftColumnProps } from './BenefitArticleLeftColumn.types';
import * as S from './BenefitArticleLeftColumn.styles';

export const BenefitArticleLeftColumn = ({
  id,
  slug,
  title,
  ingress,
  keyInformation,
  isFavorite,
  desktopCampaignAndTipsView,
  stepByStepSection,
  accessDetails,
  discountCodes,
  callToAction,
  urlParameters,
  onClickBecomeAMember,
  handleCtaBlankExternalTracking,
  body,
  meta,
  metaDisplay,
}: BenefitArticleLeftColumnProps) => (
  <>
    <BenefitTitle
      id={id}
      slug={slug}
      title={title}
      ingress={ingress}
      keyInformation={keyInformation}
      isFavorite={isFavorite}
    />
    {desktopCampaignAndTipsView.length > 0 && (
      <S.MobileWrapper $extraMargin>
        <CampaignBannerMapper
          campaigns={desktopCampaignAndTipsView}
          handleCtaBlankExternalTracking={handleCtaBlankExternalTracking}
        />
      </S.MobileWrapper>
    )}
    {body ? (
      <>
        {stepByStepSection && accessDetails?.isAccessibleForUser && (
          <StepByStepList
            title={stepByStepSection?.title}
            ingress={stepByStepSection?.ingress}
            list={stepByStepSection?.list}
            variant="outline"
            listType={stepByStepSection?.listType}
          />
        )}
        <S.DiscountWrapper>
          {discountCodes &&
            accessDetails?.isAccessibleForUser &&
            discountCodes.map((code) => (
              <S.BenefitDiscountCopyWrapper key={`discountCode-${code.discountCode}`}>
                <BenefitDiscountCopy label={code.label} discountCode={code.discountCode} variant={code.discountCode} />
              </S.BenefitDiscountCopyWrapper>
            ))}
          <CtaButton
            callToAction={callToAction}
            urlParameters={urlParameters}
            onClickBecomeAMember={onClickBecomeAMember}
            handleCtaBlankExternalTracking={handleCtaBlankExternalTracking}
            accessDetails={accessDetails}
          />
        </S.DiscountWrapper>
        <S.Body>
          <BlockContent value={body} />
        </S.Body>
      </>
    ) : (
      <LoaderContent />
    )}
    <MetaData meta={meta} metaDisplay={metaDisplay} />
  </>
);
